"use client";

import { Button, type ButtonProps } from "@mantine/core";
import { IconMessageFilled } from "@tabler/icons-react";
import Gleap from "gleap";
import { useTranslations } from "next-intl";
import { AppConfig } from "@/config";
import { env } from "@/env";

type ButtonSupportProps = ButtonProps;

// Use this button if chat is hidden on some routes. config.js has onlyShowOnRoutes set to ["/"] so it will be hidden on all routes except the home page.
// If Gleap is not enable, it will open the support email in the default email client.
const ButtonSupport = ({ size = "md", ...props }: ButtonSupportProps) => {
  const t = useTranslations("components.ButtonSupport");
  const handleClick = () => {
    if (env.NEXT_PUBLIC_GLEAP_API_KEY) {
      Gleap.startClassicForm("bugreporting", true);
    } else if (AppConfig.email?.supportEmail) {
      // open default email client in new window with "need help with ${config.appName}" as subject
      window.open(
        `mailto:${AppConfig.email.supportEmail}?subject=Need help with ${AppConfig.appName}`,
        "_blank",
      );
    }
  };

  return (
    <Button
      color="blue"
      onClick={handleClick}
      title={t("title")}
      size={size}
      leftSection={<IconMessageFilled />}
      {...props}
    >
      {t("label")}
    </Button>
  );
};

export default ButtonSupport;
